module.exports = __webpack_public_path__ + "img/careers_passion.82ee70c8.png";